import React from 'react'

/**
 * Array helper function for filtering items by value
 * @param {string} value - filter value that is searched for in item
 * @param {object} item - item to be filtered
 * @param {string} [filterBy] - property of item to be filtered
 * @returns {boolean}
 */
export const filterListItems = (value, item, filterBy) => {
    if (!value) {
        return true
    }

    if (filterBy !== 'all' && !(typeof item[filterBy] === 'string')) {
        return false
    }

    if (filterBy === 'all') {
        const { appendix, name } = item
        const compound = `${name} ${appendix}`
        return compound.toLowerCase().includes(value.toLowerCase())
    }

    return item[filterBy].toLowerCase().includes(value.toLowerCase())
}

const trimLeftRegex = /^\s+/

/**
 * Array compare function for sorting strings that does a left trim and lower case conversion before comparing.
 * Empty/null/undefined values are placed at the beginning.
 *
 * @param {string} first - The first string
 * @param {string} second - The second string
 * @return {number} -1, if first should be placed before second.
 *                   0, if the order should not be changed.
 *                   1, if second should be placed before first.
 */
export const compareStringsWithLeftTrimAndLowerCase = (first, second) => {
    if (!first) {
        return -1
    }

    if (!second) {
        return 1
    }

    // toLowerCase to prevent extra sorting of big and small names
    // Trimming left with a regex is much faster in Chrome and IE 11.
    first = first.replace(trimLeftRegex, '').toLowerCase()
    second = second.replace(trimLeftRegex, '').toLowerCase()

    if (first < second) {
        return -1
    }
    if (first > second) {
        return 1
    }
    return 0
}
